// extracted by mini-css-extract-plugin
module.exports = {"head":"Happen_head__ScD6S","contentWrap":"Happen_contentWrap__JUYJB"};